import React, { useEffect, useMemo, useState } from "react";
import { FiCheck, FiSave, FiCreditCard } from "react-icons/fi";
import FinalPaymentModal from "./FinalPaymentModal";
import {
  saveDailySettlement,
  toggleReturnsReceived,
  saveFinalSettlementPayments,
} from "./RepresentativeSettlementService";

const PaymentMethods = ({
  selectedRepresentative,
  dailyData,
  date,
  onSaved,
}) => {
  const [cashAmount, setCashAmount] = useState(0);
  const [instaPayAmount, setInstaPayAmount] = useState(0);
  const [vodafoneCashAmount, setVodafoneCashAmount] =
    useState(0);

  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [returnsReceived, setReturnsReceived] = useState(false);
  const [returnsLoading, setReturnsLoading] = useState(false);
  const [paidAmount, setPaidAmount] = useState(0);
  const [manualDueAmount, setManualDueAmount] = useState(0);
  const [paymentModal, setPaymentModal] = useState({
    isOpen: false,
    type: null,
    amount: 0,
    title: "",
  });

  useEffect(() => {
    setCashAmount(
      Number(dailyData?.cashAmount || 0)
    );

    setInstaPayAmount(
      Number(dailyData?.instaPayAmount || 0)
    );

    setVodafoneCashAmount(
      Number(dailyData?.vodafoneCashAmount || 0)
    );

    setManualDueAmount(
      dailyData?.manualDueAmount !== null &&
      dailyData?.manualDueAmount !== undefined
        ? Number(dailyData.manualDueAmount)
      : 0
    );

    setPaidAmount(
     Number(dailyData?.paidAmount || 0)
    );
   

    setNotes(dailyData?.notes || "");

    setReturnsReceived(
      Boolean(dailyData?.isReturnsReceived)
    );
  }, [dailyData]);



  /* ================================
     إجمالي المستحق
  ================================= */

  const totalDue = Number(
    dailyData?.totalDue ??
      dailyData?.currentRemaining ??
      0
  );


  /* ================================
     المتبقي
  ================================= */

  const remainingAmount = Math.max(
    totalDue - paidAmount,
    0
  );


  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString("ar-EG");
  };

  /* ================================
     حفظ التسوية
  ================================= */
  const handleToggleReturnsReceived = async () => {
    if (!selectedRepresentative?.id || !date) {
      return;
    }

    const newValue = !returnsReceived;

    try {
      setReturnsLoading(true);

      await toggleReturnsReceived({
        representativeId: selectedRepresentative.id,
        dailyDate: `${date}T00:00:00`,
        isReturnsReceived: newValue,
      });

      setReturnsReceived(newValue);
    } catch (error) {
      console.error(
        "toggle returns received error:",
        error
      );
    } finally {
      setReturnsLoading(false);
    }
  };

  const handleSaveSettlement = async () => {
    if (!selectedRepresentative?.id) {
      return;
    }

    try {
      setSaving(true);

      await saveDailySettlement({
        representativeId:
          selectedRepresentative.id,
        dailyDate: `${date}T00:00:00`,
        cashAmount:
          Number(cashAmount) || 0,
        instaPayAmount:
          Number(instaPayAmount) || 0,
        vodafoneCashAmount:
          Number(vodafoneCashAmount) || 0,
        manualDueAmount:
          Number(manualDueAmount) || 0,
        notes: notes || "",
      });

      if (onSaved) {
        onSaved();
      }

    } catch (error) {
      console.error(
        "save settlement error:",
        error
      );
    } finally {
      setSaving(false);
    }
  };

 const openPaymentModal = ({
  type,
  amount,
  title,
}) => {
  setPaymentModal({
    isOpen: true,
    type,
    amount: Number(amount) || 0,
    title,
  });
};

const closePaymentModal = () => {
  setPaymentModal({
    isOpen: false,
    type: null,
    amount: 0,
    title: "",
  });
}


const finalRemainingAmount =
  Number(paidAmount || 0) - Number(dailyData?.deliveredAmount || 0);

return (
  <section className="settlement-section">

    <h3 className="settlement-title">
      تسوية المندوب
    </h3>

    <div className="settlement-rows">

  {/* =====================================================
      LEFT SIDE
  ====================================================== */}

  <div className="settlement-column">



    <div className="settlement-row">
      <div className="settlement-label">
        المستحق /
      </div>

      <div className="settlement-value">
        <input
          type="number"
          min="0"
          value={manualDueAmount}
          onChange={(event) =>
            setManualDueAmount(event.target.value)
          }
          className="settlement-input"
        />
      </div>
    </div>
    <div className="settlement-row">
      <div className="settlement-label">
        النقدي /
      </div>

      <div className="settlement-value">
        <input
          type="number"
          min="0"
          value={cashAmount}
          onChange={(event) =>
            setCashAmount(event.target.value)
          }
          className="settlement-input"
        />
      </div>
    </div>

    <div className="settlement-row">
      <div className="settlement-label">
        InstaPay /
      </div>

      <div className="settlement-value">
        <input
          type="number"
          min="0"
          value={instaPayAmount}
          onChange={(event) =>
            setInstaPayAmount(event.target.value)
          }
          className="settlement-input"
        />
      </div>
    </div>

    <div className="settlement-row">
      <div className="settlement-label">
        Vodafone Cash /
      </div>

      <div className="settlement-value">
        <input
          type="number"
          min="0"
          value={vodafoneCashAmount}
          onChange={(event) =>
            setVodafoneCashAmount(event.target.value)
          }
          className="settlement-input"
        />
      </div>
    </div>

    <div className="settlement-row">
      <div className="settlement-label">
        المسدد /
      </div>

      <div className="settlement-value">
        {formatNumber(paidAmount)}
      </div>
    </div>

   <div className="settlement-row">
  <div className="settlement-label">
    المتبقي /
  </div>

  <div
  className={`settlement-value ${
    Number(dailyData?.Remaining || 0) < 0
      ? "settlement-credit"
      : Number(dailyData?.Remaining || 0) > 0
      ? "settlement-debit"
      : ""
  }`}
>
  {Number(dailyData?.remaining || 0) < 0
    ? `للمندوب / ${formatNumber(
        Math.abs(Number(dailyData?.remaining || 0))
      )}`
    : Number(dailyData?.remaining || 0) > 0
    ? `عليه / ${formatNumber(Number(dailyData?.remaining || 0))}`
    : "0"}
</div>

</div>


  </div>

  {/* =====================================================
      RIGHT SIDE - DELIVERY / RETURNS
  ====================================================== */}

  <div className="settlement-column settlement-delivery-column">

    <div className="settlement-row">

      <div className="settlement-label">
         المسلمات /
      </div>

      <div className="settlement-value">
        {formatNumber(
          dailyData?.deliveredInvoicesCount
        )}
      </div>

    </div>

    <div className="settlement-row">

      <div className="settlement-label">
        قيمة التسليم /
      </div>

      <div className="settlement-value">
        {formatNumber(
          dailyData?.deliveredAmount
        )}
      </div>

    </div>

    <div className="settlement-row">

      <div className="settlement-label">
         خصم قيمة التسليم من اجمالي المسدد /
      </div>

       <div
        className={`settlement-value ${
          totalDue < 0
            ? "settlement-credit"
            : totalDue > 0
            ? "settlement-debit"
            : ""
        }`}
      >
        {totalDue < 0
          ? `للمندوب / ${formatNumber(
              Math.abs(totalDue)
            )}`
          : totalDue > 0
          ? `عليه / ${formatNumber(totalDue)}`
          : "0"}
      </div>

    </div>

   

    <div className="settlement-row">

      <div className="settlement-label">
         المرتجعات /
      </div>

      <div className="settlement-value">
        {formatNumber(
          dailyData?.returnedInvoicesCount
        )}
      </div>

    </div>   
    <div className="settlement-row">

      <div className="settlement-label">
         عدد المرتجعات /
      </div>

      <div className="settlement-value">
        {formatNumber(
          dailyData?.returnedItemsQuantity
        )}
      </div>

    </div>   

    <div className="settlement-row">

      <div className="settlement-label">
        قيمة المرتجعات /
      </div>

      <div className="settlement-value">
        {formatNumber(
          dailyData?.returnedAmount
        )}
      </div>

    </div>

  {/* =================================================
        النهائي للمندوب ليه وعليه
    ================================================= */}
    

   {/* النهائي للمندوب */}

<div className="settlement-row final-settlement-row">
  <div className="settlement-label">
    النهائي للمندوب /
  </div>

  <div className="settlement-value final-main-value">
    {formatNumber(dailyData?.finalForRepresentative)}
  </div>

  <button
    type="button"
    className="final-payment-button"
    onClick={() =>
      openPaymentModal({
        type: "صرف_للمندوب",
        amount: dailyData?.finalForRepresentative,
        title: "دفع للمندوب",
      })
    }
    disabled={
      Number(dailyData?.finalForRepresentative || 0) <= 0
    }
  >
    <FiCreditCard size={15} />

    <span>دفع</span>
  </button>
</div>

{/* النهائي على المندوب */}

<div className="settlement-row final-settlement-row">
  <div className="settlement-label">
    النهائي على المندوب /
  </div>

  <div className="settlement-value final-main-value">
    {formatNumber(dailyData?.finalOnRepresentative)}
  </div>

  <button
    type="button"
    className="final-payment-button"
    onClick={() =>
      openPaymentModal({
        type: "تحصيل_من_المندوب",
        amount: dailyData?.finalOnRepresentative,
        title: "تحصيل من المندوب",
      })
    }
    disabled={
      Number(dailyData?.finalOnRepresentative || 0) <= 0
    }
  >
    <FiCreditCard size={15} />

    <span>دفع</span>
  </button>
</div>

    {/* =================================================
        RETURNS RECEIVED CHECKBOX
    ================================================= */}

    <div className="settlement-row returns-received-row">

      <div className="settlement-label">
        استلام المرتجعات /
      </div>

      <div className="settlement-value">

        <label className="returns-checkbox">

          <input
            type="checkbox"
            checked={returnsReceived}
            onChange={handleToggleReturnsReceived}
            disabled={returnsLoading}
          />

          <span className="custom-checkbox">

            {returnsReceived && (
              <FiCheck size={13} />
            )}

          </span>

          <span className="returns-checkbox-text">
            {returnsLoading
              ? "جاري الحفظ..."
              : returnsReceived
              ? "تم الاستلام"
              : "لم يتم الاستلام"}
          </span>

        </label>

      </div>

    </div>

  </div>

</div>

    <div className="settlement-notes">

      <label>
        ملاحظات
      </label>

      <textarea
        value={notes}
        onChange={(event) =>
          setNotes(event.target.value)
        }
        placeholder="اكتب ملاحظات التسوية..."
      />

    </div>

    {/* =========================
        SAVE SETTLEMENT
    ========================== */}

    <div
      className="save-settlement-force"
      onClick={() => {
        if (!saving) {
          handleSaveSettlement();
        }
      }}
    >
      <FiSave size={16} />

      <span>
        {saving
          ? "جاري الحفظ..."
          : "حفظ التسوية"}
      </span>
    </div>
    
      <FinalPaymentModal
          isOpen={paymentModal.isOpen}
          onClose={closePaymentModal}
          selectedRepresentative={selectedRepresentative}
          date={date}
          amount={paymentModal.amount}
          transactionType={paymentModal.type}
          title={paymentModal.title}
          onSuccess={async () => {
            if (onSaved) {
              await onSaved();
            }
          }}
        />
  </section>
);
};

export default PaymentMethods;
